import { requestJson } from '../api.js';

export function restoreAssessment(fetchImpl) {
  return requestJson('/api/assessment', {
    method: 'GET',
    headers: {},
  }, fetchImpl);
}

export function saveDraftPatch(patch, fetchImpl) {
  return requestJson('/api/assessment/draft', {
    method: 'PATCH',
    body: JSON.stringify(patch),
  }, fetchImpl);
}

export function submitAssessment({ schemaVersion, operationId }, fetchImpl) {
  return requestJson('/api/assessment/submit', {
    method: 'POST',
    body: JSON.stringify({ schemaVersion, operationId }),
  }, fetchImpl);
}

export function restoreSubmission(fetchImpl) {
  return requestJson('/api/assessment/submission', {
    method: 'GET',
    headers: {},
  }, fetchImpl);
}
